import PropTypes from 'prop-types';
import React from 'react';

import Chevron, { SIZES } from 'components/Chevron';
import IconButton from 'components/IconButton';
import Theme from 'styles/theme';

const HomepageCarouselArrow = ({ direction, ...otherProps }) => {
  return (
    <IconButton className="HomepageCarouselArrow" {...otherProps}>
      <Chevron fillColor="colors-black-80" direction={direction} size={SIZES.LARGE} />
      <style jsx global>{`
        button.IconButton.HomepageCarouselArrow {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid ${Theme.get('colors-black-20')};
          width: ${Theme.get('spacing') * 8}px;
          height: ${Theme.get('spacing') * 8}px;
          border-radius: 50%;
          background-color: ${Theme.get('colors-white')};
          box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.25);
          transition: border-color ease-in-out ${Theme.get('transition-duration') / 2}ms;
        }

        button.IconButton.HomepageCarouselArrow:hover,
        button.IconButton.HomepageCarouselArrow.focused {
          border-color: ${Theme.get('colors-black-60')};
        }
      `}</style>
    </IconButton>
  );
};

HomepageCarouselArrow.propTypes = {
  direction: PropTypes.string,
};

HomepageCarouselArrow.defaultProps = {
  direction: 'left',
};

export default HomepageCarouselArrow;
